// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ic-Y","search":"Settings_search__hpIvN","filter":"Settings_filter__15Oi1"};